/**
 * access an object property by dot notation string
 * ie {a: {b: 1}} path will be a.b to access b
 * @param obj
 * @param path
 */
export var accessPropertyByDotNotationString = function accessPropertyByDotNotationString(obj, path) {
  return path.split('.').reduce(function (acc, part) {
    return acc && acc[part];
  }, obj);
};
/**
 * set an object property by dot notation string
 * @param obj
 * @param path
 * @param value
 */

export var setPropertyByDotNotationString = function setPropertyByDotNotationString(obj, path, value) {
  var ref = obj;
  var paths = path.split('.');
  paths.forEach(function (part, index) {
    if (index === paths.length - 1) {
      ref[part] = value;
      return;
    }

    ref = obj[part];
  });
};